import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { MychampService, Dropobj } from '../services/mychamp.service';
import { HttpClient } from '@angular/common/http';
import { VirtualScrollerComponent } from 'ngx-virtual-scroller';


@Component({
  selector: 'app-library',
  templateUrl: './library.component.html',
  styleUrls: ['./library.component.css'],
  providers:[MychampService]
})
export class LibraryComponent implements OnInit {
  infocount:any={};
  bookslst:any=[];
  arropac:any=[];
  arrelink:any=[];
  arrqbank:any=[];
  

  constructor(private http: HttpClient, private mservice: MychampService) { }

  ngOnInit(): void {
    this.booksb0rowed_infocont();
  }

  booksb0rowed_infocont()
  {
      this.mservice.boooksborowed('booksissued',4459)
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-dashcounts',resultArray) ;
      this.infocount=resultArray.infocount[0];
      this.bookslst=resultArray.bookslst;


      },
     error => console.log('Error :: ' + error)
  );
  }

  opac(oprtype,memid,sertxt)
  {

    
      this.mservice.libopac_elink_quest(oprtype,4459,sertxt)
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-dashcounts',resultArray) ;
      //this.infocount=resultArray.infocount[0];
      this.arropac=resultArray;


      },
     error => console.log('Error :: ' + error)
  );
  }


  seropac(filterValue: string) {
    debugger
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
  
    if(filterValue.length>=3)
    {
      
    this.opac('serchopac',0,filterValue);
  }
  else 
  {
    this.opac('seltop10opac',0,'');
  }
  
  }
  

  elinks(oprtype,memid,sertxt)
  {
      this.mservice.libopac_elink_quest(oprtype,4459,sertxt)
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-dashcounts',resultArray) ;
      //this.infocount=resultArray.infocount[0];
      this.arrelink=resultArray;


      },
     error => console.log('Error :: ' + error)
  );
  }

  
  serelink(filterValue: string) {
    debugger
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
  
    if(filterValue.length>=3)
    {
      
    this.elinks('serelink',0,filterValue);
  }
  else 
  {
    this.elinks('seltopelink',0,'');
  }
  
  }
  

  qbanks(oprtype,memid,sertxt)
  {
      this.mservice.libopac_elink_quest(oprtype,4459,sertxt)
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-dashcounts',resultArray) ;
      //this.infocount=resultArray.infocount[0];
      this.arrqbank=resultArray;


      },
     error => console.log('Error :: ' + error)
  );
  }

  serqbank(filterValue: string) {
    debugger
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
  
    if(filterValue.length>=3)
    {
      
    this.qbanks('serqbank',0,filterValue);
  }
  else 
  {
    this.qbanks('seltopqbank',0,'');
  }
  
  }
  

}
